import PrivateSerieModel from "#src/models/PrivateSerieModel.ts";
import { RegistrationDiscount } from "#src/utils/calculateDiscounts.ts";
import { moment, Moment } from "#src/utils/dateTime.ts";
import { Frequency, PaymentFrequency } from "#types/code-generator.ts";
import { v4 as uuid } from "uuid";
import calculateNumberOfClassesFromDate from "./calculateNumberOfClassesFromDate";

interface CalculatePricingForPrivateSerie {
  privateSerie: PrivateSerieModel;
  organization: {
    departments: {
      id: string;
    }[];
    timezone: string;
  };
  startDate?: Moment;
}

export function calculatePricingForPrivateSerie(
  args: CalculatePricingForPrivateSerie
) {
  let price = 0;
  let pricePerSession = 0;
  let numberRemaining = 0;
  let discount;
  const discountsToAdd = [];

  let priceAdjustments = [...args.privateSerie.offering.priceAdjustments].sort(
    (a, b) => a.min - b.min
  );
  let discounts: RegistrationDiscount[] = [
    ...(args.privateSerie.offering.discounts || []),
  ].sort((a, b) => a.min - b.min);

  if (args.privateSerie.isExtending) {
    priceAdjustments = [
      ...args.privateSerie.offering.extensionPriceAdjustments,
    ].sort((a, b) => a.min - b.min);

    discounts = [...args.privateSerie.offering.extensionDiscounts].sort(
      (a, b) => a.min - b.min
    );
  }

  // console.log("discounts", discounts);
  // console.log("privateSerie", args.privateSerie);

  if (args.privateSerie.offering.frequency === Frequency.Monthly) {
    let startDate = moment();

    if (args.startDate) {
      startDate = args.startDate.clone();
    }

    const offeringStartDate = moment(args.privateSerie.offering.startDate);
    let offeringEndDate = moment(args.privateSerie.offering.endDate);
    let endDate = startDate.clone().endOf("month");

    if (offeringStartDate.isAfter(startDate)) {
      startDate = offeringStartDate;
    }

    if (offeringEndDate.isBefore(endDate)) {
      endDate = offeringEndDate;
    }

    numberRemaining = calculateNumberOfClassesFromDate({
      classItem: args.privateSerie.offering,
      endDate,
      startDate,
      organization: args.organization,
    });

    // console.log("numberRemaining", numberRemaining);

    price = numberRemaining * args.privateSerie.offering.price;
  } else if (
    args.privateSerie.offering.paymentFrequency === PaymentFrequency.Manual
  ) {
    price = 0;
    pricePerSession = args.privateSerie.offering.price;

    if (priceAdjustments.length > 0) {
      for (const pa of priceAdjustments) {
        if (args.privateSerie.roster.length >= (pa.min || 0)) {
          pricePerSession = pa.price;
        }
      }
    }
  } else {
    pricePerSession = args.privateSerie.offering.price;

    if (
      args.privateSerie.isExtending &&
      args.privateSerie.offering.extensionPrice
    ) {
      pricePerSession = args.privateSerie.offering.extensionPrice;
    }

    if (priceAdjustments.length > 0) {
      for (const pa of priceAdjustments) {
        if (args.privateSerie.roster.length >= (pa.min || 0)) {
          pricePerSession = pa.price;
        }
      }
    }

    price = pricePerSession * args.privateSerie.numberOfLessons;

    if (discounts.length > 0) {
      for (const d of discounts) {
        if (
          args.privateSerie.numberOfLessons >= d.min &&
          (!d.max || args.privateSerie.numberOfLessons <= d.max)
        ) {
          discount = d;
        }
      }

      if (discount) {
        const discountPercentage = discount.amount / 100;
        const discountAmount =
          pricePerSession - pricePerSession * discountPercentage;
        const discountPrice =
          discountAmount * args.privateSerie.numberOfLessons;

        discountsToAdd.push({
          id: uuid(),
          amount: price - discountPrice,
        });

        // pricePerSession -= discountAmount;
      }
    }
  }

  // console.log("pricePerSession", pricePerSession);

  return {
    price,
    pricePerSession,
    discounts: discountsToAdd,
  };
}
